module.exports = __webpack_public_path__ + "static/media/pathChart.94015bd7.png";